<template>
  <header>
    <!-- top bar -->
    <div
      class="d-flex justify-content-between w-100 bg-white z-50 px-xl-2"
      :class="{ 'position-fixed top-0': isShowMenu, 'position-xl-relative': true }"
    >
      <!-- left -->
      <div class="d-flex align-items-center p-1 p-xl-3">
        <router-link
          :to="{ name: 'AI_Home' }"
          v-if="authorized"
          class="d-none d-xl-inline-block pointer"
        >
          <img
            class="d-block mx-auto img-fluid"
            src="@/assets/image/gept/backRouter.png"
            alt=""
          />
        </router-link>

        <!-- hamburger -->
        <div class="ham-outer xl-hidden d-xl-none" v-if="authorized">
          <svg
            class="ham hamRotate ham1"
            :class="{ active: isShowMenu }"
            viewBox="0 0 100 100"
            width="80"
            @click="isShowMenu = !isShowMenu"
          >
            <path
              class="line top"
              d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
            />
            <path class="line middle" d="m 30,50 h 40" />
            <path
              class="line bottom"
              d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
            />
          </svg>
        </div>
      </div>

      <!-- center -->
      <div class="d-flex align-items-center justify-content-center py-3">
        <img
          class="d-block img-fluid mr-2"
          src="@/assets/image/gept/logo_header.png"
          alt=""
        />
        <p class="gept_main_color_light text-xl fw-black mb-0">
          {{ $route.path.includes('quiz') ? '學測寫作' : 'GEPT 模擬練習' }}
        </p>
      </div>

      <!-- right -->
      <div>
        <div class="d-none d-xl-flex align-items-center font-bold p-1 p-xl-3">
          <p class="p-2 mb-0" v-if="user?.email">
            {{ user.email }}
          </p>

          <div class="d-flex align-items-center mx-2 login-purple-text">
            <img
              class="img-fluid mr-1"
              src="@/assets/image/gept/star.png"
              alt=""
            />
            <p class="mb-0">
              <span class="small">{{ remainPoints }}</span> 點
            </p>
          </div>

          <a class="d-inline-block p-2 pointer text-secondary" @click="logout2()">
            登出
          </a>
        </div>
      </div>
    </div>

    <!-- sidebar -->
    <div
      class="w-100 position-fixed z-50 d-xl-none gept_main_bg Sidebar-outer"
      v-if="isShowMenu"
    >
      <Sidebar
        :menuData="menuData"
        class="max-w-100 sidebar"
        @closeMenu="isShowMenu = false"
      />
    </div>
  </header>
</template>


<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/AiHelper/GEPT/sidebar'
export default {
  name: 'headerSection',
  props: {
    menuData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'remainPoints',
      'level'
    ]),

    urlPath () {
      return 'https://aieta.liveabc.com/study_records.php'
    },
    levelPath () {
      if (this.$route.params.practice_type === 'speaking') {
        return 'https://aieta.liveabc.com/?list_gept_speaking_1'
      }
      return 'https://aieta.liveabc.com/?list_gept_speaking_2'
    }
  },
  components: {
    Sidebar
  },
  data () {
    return {
      isShowMenu: false,
      user: null
    }
  },
  mounted () {
    this.$store.dispatch('getRemainPoints')
  },
  watch: {
  },
  methods: {
    async getUser () {
      const { data } = await api.get('/me')
      this.user = data
    },
    logout () {
      this.$store.dispatch('logout')
    },
    logout2 () {
      this.$store.dispatch('logout')
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>
<style lang="scss" scoped>
.position-xl-relative {
  @media (min-width: 1280px) {
      position: relative !important;
  }
}
.login-purple-text {
  color: #BC00EB;
}
.Sidebar-outer {
  z-index: 99;
  top: 73px;
  height: calc(100vh - 73px);
  overflow-y: scroll;
  .sidebar {
    height: 100%;
  }
}
.ham-outer {
  width: 50px;
  height: 50px;
  align-items: center;
  display: flex;
  height: 100%;
  overflow: hidden;
}
.ham {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 400ms;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.hamRotate.active {
  transform: rotate(45deg);
}
.hamRotate180.active {
  transform: rotate(180deg);
}
.line {
  fill:none;
  transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
  stroke:#000;
  stroke-width:5.5;
  stroke-linecap:round;
}
.ham1 .top {
  stroke-dasharray: 40 139;
}
.ham1 .bottom {
  stroke-dasharray: 40 180;
}
.ham1.active .top {
  stroke-dashoffset: -98px;
}
.ham1.active .bottom {
  stroke-dashoffset: -138px;
}
</style>